import { defineMessages } from "./define.js";

/**
 * What a push says when its own text cannot be read.
 *
 * Read from the service worker, which imports this file directly rather than
 * going through `t()` — see `sw/push.ts`. So keep it plain: no placeholders,
 * nothing that needs a count, one line per notification type.
 */
export const notify = defineMessages("notify", {
  messageNew: { ru: "Новое сообщение", en: "New message" },
  itemAssigned: { ru: "Вам назначено дело", en: "A task for you" },
  itemDue: { ru: "Скоро срок", en: "Due soon" },
  eventSoon: { ru: "Скоро событие", en: "Event coming up" },
  wishAdded: { ru: "Новая хотелка", en: "A new wish" },
  placeAdded: { ru: "Новое место на карте", en: "A new place on the map" },
  spaceJoined: { ru: "Новый участник в пространстве", en: "Someone joined the space" },
  /* Имя сервер знает открыто (§3), а слова — дело того, кто показывает. */
  spaceJoinedBy: { ru: "Новый участник: {name}", en: "{name} joined the space" },
  /* «Скоро событие» без ответа на «какое» и «во сколько» — почти ничего. Час
     сервер может назвать всегда: время это колонка. Название достаётся с
     устройства, где лежит ключ. */
  eventSoonAt: { ru: "Событие в {time}", en: "An event at {time}" },
  itemDueAt: { ru: "Срок в {time}", en: "Due at {time}" },
  atTime: { ru: "в {time}", en: "at {time}" },
  /* Кнопки на самом уведомлении: то, чем напоминание обычно и отвечают. */
  actionDone: { ru: "Сделано", en: "Done" },
  actionGoing: { ru: "Иду", en: "I'm going" },
  something: {
    ru: "Что-то произошло в пространстве",
    en: "Something happened in the space",
  },
});
